import config from '@/config';
import { requests } from '.';
//can be used to specify version later on staging
const getBaseUrl = () => {
    if (config.USE_VERSION) {
        return config.VERSION_DETAILS.CONVERSATIONS_SERVICE_URL;
    }
    return config.CONVERSATIONS_SERVICE_URL;
};
const getVersion = () => {
    if (config.USE_VERSION) {
        return config.VERSION_DETAILS.DEVELOPER_VERSION;
    }
    return null;
};
const CONVERSATIONS_SERVICE_URL = config === null || config === void 0 ? void 0 : config.CONVERSATIONS_SERVICE_URL;
export const ConversationService = {
    create: (params) => requests(config.CONVERSATIONS_SERVICE_URL).post('/', params),
    get: conversationId => requests(config.CONVERSATIONS_SERVICE_URL).get(`/${conversationId}`),
    generateSuggestions: messageId => requests(config.CONVERSATIONS_SERVICE_URL).post(`/messages/${messageId}/suggestions`),
    searchConversations: (conversationId, type) => requests(config.CONVERSATIONS_SERVICE_URL).get(`/messages/search?conversationId=${conversationId}&type=${type}`),
    putBotToSleep: (conversationId, body) => requests(config.CONVERSATIONS_SERVICE_URL).put(`/${conversationId}`, body),
    sendMessage: (body) => requests(CONVERSATIONS_SERVICE_URL).post('/messages', body),
    uploadAttachments: (formData) => {
        return requests(CONVERSATIONS_SERVICE_URL).post('/messages/upload', formData);
    },
    checkForSpam: (body) => {
        return requests(CONVERSATIONS_SERVICE_URL).post('/messages/spam/v2', body);
    },
    getEmailMessageDetails: (emailMessageId) => {
        return requests(CONVERSATIONS_SERVICE_URL).get(`/messages/email/${emailMessageId}`);
    },
    resendEmail: (emailMessageId, locationId) => {
        return requests(config.newBaseUrl).post(`/message/resend/email/${emailMessageId}?location_id=${locationId}`);
    },
    requestContactDetails: body => {
        return requests(CONVERSATIONS_SERVICE_URL).post(`/providers/live-chat/user/request/contact`, body);
    },
    endLiveChat: body => {
        return requests(CONVERSATIONS_SERVICE_URL).post(`/providers/live-chat/user/close`, body);
    },
    typingStatus: body => {
        return requests(CONVERSATIONS_SERVICE_URL).post(`/providers/live-chat/typing`, body);
    },
};
